import React from 'react'
import { IonPage, IonContent } from '@ionic/react'
import { useHistory } from 'react-router'
import InitialConfigHeader from '../header'
import ProtocolSelection from '../../../components/ProtocolSelection'
import '../InitialConfiguration.min.css'

const ProtocolSelectionPage = ({ step, totalSteps }) => {
	const history = useHistory()

	const handleComplete = () => {
		// Continue to next step (NicknamePage)
		history.push(`/impostazioni-iniziali/${step + 1}`)
	}

	return (
		<IonPage className="initial-configuration">
			<InitialConfigHeader
				step={step}
				totalSteps={totalSteps}
				isLoading={false}
			/>
			<IonContent>
				<ProtocolSelection
					onComplete={handleComplete}
					step={step}
					totalSteps={totalSteps}
				/>
			</IonContent>
		</IonPage>
	)
}

export default ProtocolSelectionPage
